// src/store/slices/categorySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CategoryInputRef {
  fieldName: string;
  rowId: any;
  element: any | null;
  elementId: any | null; // Store the reference directly
}

// Define initial state
interface CategoryState {
  categoryInputRef: CategoryInputRef | null;
}

const initialState: CategoryState = {
  categoryInputRef: null
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setCategoryInputRefs: (state, action: PayloadAction<CategoryInputRef | null>) => {
      state.categoryInputRef = action.payload;
    },
    clearCategoryInputRef: (state) => {
      state.categoryInputRef = null;
    }
  }
});

export const { setCategoryInputRefs, clearCategoryInputRef } = categorySlice.actions;

export default categorySlice.reducer;
